import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { coreTeam, studioImage, workingApproach } from '../../data/about';
export function TeamSection() {
  return <Section tone="surface" bordered labelledBy="team-title" data-id="element-78" data-mp="2yxew27bc1u8i">
      <Container data-id="element-79" data-mp="2yxwzpp0braqg">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-10" data-id="element-80" data-mp="2yzhunfqjwvou">
          <div className="lg:col-span-5" data-id="element-81" data-mp="2b8lw7zrlb28m">
            <Reveal data-id="element-82" data-mp="2b9niz1hyxd66">
              <figure data-id="element-83" data-mp="268zjdrfobo0c">
                <AppImage src={studioImage.image} alt={studioImage.alt} ratio="3:4" data-id="element-84" data-mp="269suf4lo0zoa" />
                <figcaption className="mt-4 text-small text-muted" data-id="element-85" data-mp="2l6jm0rp3l73c">
                  {studioImage.caption}
                </figcaption>
              </figure>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7" data-id="element-86" data-mp="f9l7dg5baoe">
            <Reveal data-id="element-87" data-mp="hvsdbz4jo63">
              <h2 id="team-title" className="max-w-[18ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-88" data-mp="3rm2mehaxv9sx">
                {coreTeam.title}
              </h2>
              <p className="mt-7 max-w-measure text-body text-muted" data-id="element-89" data-mp="7rbio33qfwv5">{coreTeam.description}</p>
            </Reveal>

            <Reveal delay={0.06} className="mt-12" data-id="element-90" data-mp="csipnzy1ws0r">
              <ul className="border-t border-hairline" data-id="element-91" data-mp="gssz5ml1y0kd">
                {workingApproach.map(area => <li key={area.title} className="border-b border-hairline py-7" data-id="element-92" data-mp="3g86c6ryn44wk">
                    <p className="text-[20px] leading-[1.3] tracking-[-0.02em] text-ink" data-id="element-93" data-mp="3l70rvl1b9dcg">
                      {area.title}
                    </p>
                    <p className="mt-4 max-w-[52ch] text-small leading-6 text-muted" data-id="element-94" data-mp="3p7t1wgi0bm9s">
                      {area.description}
                    </p>
                  </li>)}
              </ul>
            </Reveal>

            <Reveal delay={0.12} className="mt-10" data-id="element-95" data-mp="2xfc7cquqdt62">
              <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-96" data-mp="31i8hdt67ggye">
                Specialists we bring in when a project needs one
              </p>
              <ul className="mt-5 flex flex-wrap gap-2" data-id="element-97" data-mp="3pgk4m32c3mn">
                {coreTeam.roles.map(role => <li key={role} className="rounded-full border border-hairline px-3 py-1.5 text-[13px] text-muted" data-id="element-98" data-mp="ie39zhqbgds4">
                    {role}
                  </li>)}
              </ul>
            </Reveal>
          </div>
        </div>
      </Container>
    </Section>;
}